import { useRedux } from "hooks";
import { createSelector } from "reselect";
import ReactDOM from "react-dom";
import { useCallback, useEffect, useState } from "react";
import { setOrgDdlValueForPerm } from "../src/redux/actions";
import { APIClient } from "api/apiCore";
import * as url from "api/urls"
import { backdropStyle, modalStyle } from "DialogProviderShare";
import { Utils } from "helpers/utils";
import { debounce } from "lodash";
import { FormControlLabel, Switch } from "@mui/material";
import Loader from "components/Loader";
import { SettingsState } from "../src/redux/settings/types";
import Select, { components, useStateManager } from 'react-select';
import LoadingIconWithText from "components/LoadingIconWithText";

export function DialogProviderPermConfigPortal({ permName, entryId, permKey, defaultAllow, onClose }: { permName: string, entryId: number | null, permKey: string, defaultAllow: boolean, onClose: (v: any) => void }) {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Settings,
    (state: any) => state.Profile2,
    (st: SettingsState, p2) => ({
      activeTool: st.activeTool,
      isAdmin: p2.isAdmin,
      orgDllValueForPerm: st.orgDllValueForPerm,
    })
  );
  const { activeTool, isAdmin, orgDllValueForPerm } = useAppSelector(storeData);

  const [loading, setLoading] = useState(false);
  const [ddlUserType, setddlUserType] = useState<any[] | null>(null);
  const [ddlCompany, setddlCompany] = useState<any[] | null>(null);
  const [ddlDivison, setDdlDivison] = useState<any[] | null>(null);
  const [ddlDepartment, setDdlDepartment] = useState<any[] | null>(null);
  const [ddlPosition, setDdlPosition] = useState<any[] | null>(null);
  const [ddlUser, setDdlUser] = useState<any[] | null>(null);
  const [orgDllValueForPermLoading, setOrgDllValueForPermLoading] = useState<boolean>(false);

  const [permAllow, setPermAllow] = useState<boolean>(defaultAllow);
  const [selUserType, setSelUserType] = useState<any[]>([]);
  const [selCompany, setSelCompany] = useState<any[]>([]);
  const [selDivision, setSelDivision] = useState<any[]>([]);
  const [selDepartment, setSelDepartment] = useState<any[]>([]);
  const [selPosition, setSelPosition] = useState<any[]>([]);
  const [selUser, setSelUser] = useState<any[]>([]);

  const [ddlCompanyFilter, setddlCompanyFilter] = useState<any[]>([]);
  const [ddlDivisionFilter, setddlDivisionFilter] = useState<any[]>([]);
  const [ddlDepartmentFilter, setDdlDepartmentFilter] = useState<any[]>([]);
  const [ddlPositionFilter, setDdlPositionFilter] = useState<any[]>([]);
  const [ddlUserFilter, setDdlUserFilter] = useState<any[]>([]);

  const onDllItemSelected = (mode: "utype" | "company" | "div" | "dep" | "pos" | "user", values: any[]) => {
    if (mode === "utype") {
      setSelUserType(values);
    } else if (mode === "company") {
      setSelCompany(values);
    } else if (mode === "div") {
      setSelDivision(values);
    } else if (mode === "dep") {
      setSelDepartment(values);
    } else if (mode === "pos") {
      setSelPosition(values);
    } else if (mode == "user") {
      setSelUser(values);
    }
  }

  useEffect(() => {
    setddlCompanyFilter(filter("comp"));
  }, [ddlCompany, selUserType]);

  useEffect(() => {
    setddlDivisionFilter(filter("div"));
  }, [ddlDivison, selUserType, selCompany]);

  useEffect(() => {
    setDdlDepartmentFilter(filter("dept"));
  }, [ddlDepartment, selUserType, selCompany, selDivision]);

  useEffect(() => {
    setDdlPositionFilter(filter("pos"));
  }, [ddlPosition, selUserType, selCompany, selDivision, selDepartment]);

  useEffect(() => {
    setDdlUserFilter(filter("emp"));
  }, [ddlUser, selUserType, selCompany, selDivision, selDepartment, selPosition]);

  const mapData = {
    "comp": ddlCompany,
    "div": ddlDivison,
    "dept": ddlDepartment,
    "pos": ddlPosition,
    "emp": ddlUser
  }

  const filter = (type: "comp" | "div" | "dept" | "pos" | "emp"): any[] => {
    const inputData = mapData[type] || null;
    if (!inputData) return [];

    const level = [/*0*/"comp", /*1*/"div", /*2*/"dept", /*3*/"pos", /*4*/"emp"].indexOf(type);
    const selUType = selUserType.map(e => e.userType);
    const selComp = level < 1 ? [] : selCompany.map(e => e.companyName);
    const selDiv = level < 2 ? [] : selDivision.map(e => e.divisionName);
    const selDep = level < 3 ? [] : selDepartment.map(e => e.departmentName);
    const selPos = level < 4 ? [] : selPosition.map(e => e.positionName);
    // if (type === "comp") {
    //   console.log('filter ' + type + ':', { level, selUType, selComp, selDiv, selDep, selPos });
    // }

    const ddlFilter = inputData?.filter(x => {
      const utMatch = selUType.length <= 0 || selUType.includes(x.userType);
      const compMatch = selComp.length <= 0 || selComp.includes(x.companyName);
      const divMatch = selDiv.length <= 0 || selDiv.includes(x.divisionName);
      const depMatch = selDep.length <= 0 || selDep.includes(x.departmentName);
      const posMatch = selPos.length <= 0 || selPos.includes(x.positionName);
      return utMatch && compMatch && divMatch && depMatch && posMatch;
    });
    // if (type === "comp") {
    //   console.log('ddlFilter:', ddlFilter);
    // }
    return ddlFilter;
  }

  useEffect(() => {
    try {
      // console.log('orgDllValueForPerm: ', { orgDllValueForPerm });
      if (!orgDllValueForPerm && !orgDllValueForPermLoading) {
        setOrgDllValueForPermLoading(true);

        const api = new APIClient();
        api.fnPostForm(url.LOAD_DDL_VALUE_FOR_PERM)
          .then(rs => {
            // console.log('LOAD_DDL_VALUE_FOR_PERM:', rs);
            dispatch(setOrgDdlValueForPerm(rs));
          })
          .catch(er => {
            Utils.HandleException(er, true);
          });
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  });

  useEffect(() => {
    if (orgDllValueForPerm) {

      const distinctUserType = Array.from(
        new Map(
          orgDllValueForPerm
            .filter((item: any) => item.userType) // Step 1: filter out empty name1
            .map((item: any) => {
              const label = Utils.GetUserTypeText(item.userType);
              // console.log('label:' + label);
              const updated = { ...item, label: label, value: item.userType };
              return [item.userType, updated];
            })
        ).values() // Get only the unique values
      ).sort((a: any, b: any) => a.userType - b.userType);
      // console.log('distinctUserType:', distinctUserType);

      const distinctCompany = Array.from(
        new Map(
          orgDllValueForPerm
            .filter((item: any) => item.companyName) // Step 1: filter out empty name1
            .map((item: any) => {
              const updated = { ...item, label: item.companyName, value: item.companyName };
              return [item.companyName, updated];
            })
        ).values() // Get only the unique values
      ).sort((a: any, b: any) => a.companyName.localeCompare(b.companyName));
      // console.log('distinctCompany:', distinctCompany);

      const distinctDiv = Array.from(
        new Map(
          orgDllValueForPerm
            .filter((item: any) => item.divisionName) // Step 1: filter out empty name1
            .map((item: any) => {
              const updated = { ...item, label: item.divisionName, value: item.divisionName };
              return [item.divisionName, updated];
            })
        ).values() // Get only the unique values
      ).sort((a: any, b: any) => a.divisionName.localeCompare(b.divisionName));

      const distinctDep = Array.from(
        new Map(
          orgDllValueForPerm
            .filter((item: any) => item.departmentName) // Step 1: filter out empty name1
            .map((item: any) => {
              const updated = { ...item, label: item.departmentName, value: item.departmentName };
              return [item.departmentName, updated];
            })
        ).values() // Get only the unique values
      ).sort((a: any, b: any) => a.departmentName.localeCompare(b.departmentName));

      const distinctPos = Array.from(
        new Map(
          orgDllValueForPerm
            .filter((item: any) => item.positionName) // Step 1: filter out empty name1
            .map((item: any) => {
              const updated = { ...item, label: item.positionName, value: item.positionName };
              return [item.positionName, updated];
            })
        ).values() // Get only the unique values
      ).sort((a: any, b: any) => a.positionName.localeCompare(b.positionName));

      const distinctEmp = (orgDllValueForPerm ?? []).sort((a: any, b: any) => a.displayName2.localeCompare(b.displayName2)).map((item: any) => ({ ...item, label: item.displayName2, value: item.userId }))
      setddlUserType(distinctUserType);
      setddlCompany(distinctCompany);
      setDdlDivison(distinctDiv);
      setDdlDepartment(distinctDep);
      setDdlPosition(distinctPos);
      setDdlUser(distinctEmp);
    }
  }, [orgDllValueForPerm]);

  useEffect(() => {
    if (entryId) {
      setLoading(true);
      const api = new APIClient();
      api.fnPostForm(url.LOAD_PERM_CONFIG2, { entryId: entryId })
        .then(rs => {
          // console.log('LOAD_PERM_CONFIG2:', rs);
          setPermAllow(rs.allow);
          setSelUserType((rs.userTypes?.split('|') ?? []).map((x: any) => ({ userType: Utils.ToNumber(x, -1) ?? -1 })));
          setSelCompany((rs.companies?.split('|') ?? []).map((x: any) => ({ companyName: x })));
          setSelDivision((rs.divisions?.split('|') ?? []).map((x: any) => ({ divisionName: x })));
          setSelDepartment((rs.departments?.split('|') ?? []).map((x: any) => ({ departmentName: x })));
          setSelPosition((rs.positions?.split('|') ?? []).map((x: any) => ({ positionName: x })));
          setSelUser((rs.userIds?.split('|') ?? []).map((x: any) => ({ userId: Utils.ToNumber(x, -1) ?? -1 })));
          setLoading(false);
        })
        .catch(er => {
          Utils.HandleException(er, true);
          setLoading(false);
        });
    }
  }, [entryId]);

  const onSave = () => {
    try {
      setLoading(true);
      const api = new APIClient();
      const parm = {
        entryId: entryId,
        permName: permKey,
        allow: permAllow,
        userTypes: selUserType.map(x => x.userType).join('|'),
        companies: selCompany.map(x => x.companyName).join('|'),
        divisions: selDivision.map(x => x.divisionName).join('|'),
        departments: selDepartment.map(x => x.departmentName).join('|'),
        positions: selPosition.map(x => x.positionName).join('|'),
        userIds: selUser.map(x => x.userId).join('|'),
      }
      // console.log(parm);
      api.fnPostForm(url.SAVE_PERM_CONFIG2, parm)
        .then(rs => {
          // console.log('SAVE_PERM_CONFIG2:', rs);
          onClose(true);
          setLoading(false);
        })
        .catch(er => {
          Utils.HandleException(er, true);
          setLoading(false);
        })
    } catch (e) {
      Utils.HandleException(e, true);
      setLoading(false);
    }
  }

  const onDel = () => {
    setLoading(true);
    new APIClient().fnPostForm(url.DEL_PERM_CONFIG2, { entryId: entryId })
      .then(rs => {
        setLoading(false);
        onClose(true);
      })
      .catch(er => {
        Utils.HandleException(er, true);
        setLoading(false);
      });

  }

  const [loadingUser, setLoadingUser] = useState<boolean>(false);
  const [usersByFilter, setUsersByFilter] = useState<any[]>([]);
  const dbcLoadUser = useCallback(
    debounce((parm) => {
      setLoadingUser(true);
      const api = new APIClient();
      // console.log('call api:', parm);
      api.fnPostForm(url.LOAD_PERM_CONFIG2_USER_BY_FILTER, parm)
        .then(rs => {
          setUsersByFilter(rs);
          setLoadingUser(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setLoadingUser(false);
        });
    }, 1000),
    []
  );

  useEffect(() => {
    const parm = {
      entryId: entryId,
      permName: permKey,
      allow: permAllow,
      userTypes: selUserType.map(x => x.userType).join('|'),
      companies: selCompany.map(x => x.companyName).join('|'),
      divisions: selDivision.map(x => x.divisionName).join('|'),
      departments: selDepartment.map(x => x.departmentName).join('|'),
      positions: selPosition.map(x => x.positionName).join('|'),
      userIds: selUser.map(x => x.userId).join('|'),
    }
    dbcLoadUser(parm);
  }, [selUserType, selCompany, selDivision, selDepartment, selPosition, selUser]);

  const onViewUserList = async () => {
    try {
      let html = ``;
      html += `<div class="div-table-fix-header-light" style = "overflow:auto; max-height:calc(100vh - 350px)"> `;
      html += `<table width="100%" class="table-alert"> `;
      html += `<thead>`;
      html += `<tr>`;
      html += ` <th align = "center"> No</th>`;
      html += ` <th align = "center"> ประเภท</th>`;
      html += ` <th align = "center"> บริษัท</th> `;
      html += ` <th align = "center"> หน่วยงาน</th> `;
      html += ` <th align = "center"> แผนก</th> `;
      html += ` <th align = "center"> ตำแหน่ง</th> `;
      html += ` <th align = "center"> ชื่อ</th> `;
      html += `</tr> `;
      html += `</thead>`;
      html += `<tbody>`;
      if (usersByFilter.length <= 0) {
        html += `<tr>`;
        html += ` <td align = "center" colspan = "7"> ไม่มีข้อมูล</td> `;
        html += `</tr> `;
      } else {
        usersByFilter.map((x: any, idx: number) => {
          html += `<tr>`;
          html += ` <td> ${idx + 1}</td> `;
          html += ` <td> ${Utils.GetUserTypeText(x.userType)}</td> `;
          html += ` <td> ${x.companyName ?? ""}</td> `;
          html += ` <td> ${x.divisionName ?? ""}</td> `;
          html += ` <td> ${x.departmentName ?? ""}</td> `;
          html += ` <td> ${x.positionName ?? ""}</td> `;
          html += ` <td> ${x.displayName2 ?? ""}</td> `;
          html += `</tr> `;
        });
      }
      html += `</tbody>`;
      html += `</table> `;
      html += `</div> `;
      Utils.SweetAlert(html, "calc(100vw - 100px)");
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return ReactDOM.createPortal(
    <div style={backdropStyle}>
      <div style={modalStyle}>
        {loading && <Loader />}
        <h3 style={{ marginTop: 0, borderBottom: "dashed 1px var(--m2-line-divider-color)" }}>กำหนดสิทธิ์ - <span className="text-danger">{permName}</span></h3>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex justify-content-between">
                <FormControlLabel
                  control={<Switch checked={permAllow} onChange={(e) => setPermAllow(e.target.checked)} />}
                  label={permAllow ? (<span className="text-success">อนุญาต</span>) : (<span className="text-danger">ไม่อนุญาติ</span>)} />

                <span className="text-info hand" onClick={onViewUserList}><u>คลอบคลุม {loadingUser ? (<LoadingIconWithText loadingText={""} />) : (<>{usersByFilter.length}</>)} รายชื่อ</u></span>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Select
                  isMulti={true}
                  placeholder="ประเภทผู้ใช้"
                  options={ddlUserType as any[]}
                  styles={Utils.GetThemeForReactSelect()}
                  onChange={(e: any) => onDllItemSelected("utype", e)}
                  value={ddlUserType?.filter(x1 => selUserType.map(x => x.userType).includes(x1.userType))}
                  isClearable={true}
                ></Select>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Select
                  isMulti={true}
                  placeholder="บริษัท"
                  options={ddlCompanyFilter}
                  styles={Utils.GetThemeForReactSelect()}
                  onChange={(e: any) => onDllItemSelected("company", e)}
                  value={ddlCompany?.filter(x1 => selCompany.map(x => x.companyName).includes(x1.companyName))}
                  isClearable={true}
                ></Select>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Select
                  isMulti={true}
                  placeholder="หน่วยงาน"
                  options={ddlDivisionFilter}
                  styles={Utils.GetThemeForReactSelect()}
                  onChange={(e: any) => onDllItemSelected("div", e)}
                  // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
                  //value={item.division ? ddlDivison?.find(t => t.value === item.division) : null}
                  value={ddlDivison?.filter(x1 => selDivision.map(x => x.divisionName).includes(x1.divisionName))}
                  isClearable={true}
                ></Select>
              </div>
            </div>
            <div className="row">

              <div className="col-12">
                <Select
                  isMulti={true}
                  placeholder="แผนก"
                  options={ddlDepartmentFilter}
                  styles={Utils.GetThemeForReactSelect()}
                  onChange={(e: any) => onDllItemSelected("dep", e)}
                  // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
                  value={ddlDepartment?.filter(x1 => selDepartment.map(x => x.departmentName).includes(x1.departmentName))}
                  isClearable={true}
                ></Select>
              </div>
            </div>
            <div className="row">

              <div className="col-12">
                <Select
                  isMulti={true}
                  placeholder="ตำแหน่ง"
                  options={ddlPositionFilter}
                  styles={Utils.GetThemeForReactSelect()}
                  onChange={(e: any) => onDllItemSelected("pos", e)}
                  // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
                  value={ddlPosition?.filter(x1 => selPosition.map(x => x.positionName).includes(x1.positionName))}
                  isClearable={true}
                ></Select>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Select
                  isMulti={true}
                  placeholder="พนักงาน"
                  options={ddlUserFilter}
                  styles={Utils.GetThemeForReactSelect()}
                  onChange={(e: any) => onDllItemSelected("user", e)}
                  // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
                  value={ddlUser?.filter(x1 => selUser.map(x => x.userId).includes(x1.userId))}
                  isClearable={true}
                ></Select>
              </div>
              {/* <div className="col">
                <input type="text" className="form-control" placeholder="พนักงาน" />
              </div>                                                   */}
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 8, borderTop: "dashed 1px var(--m2-line-divider-color)" }}>
            <div>
              <button className="btn btn-danger" onClick={onDel} disabled={loading}>ลบ</button>
            </div>
            <div>
              <button className="btn btn-warning" onClick={() => onClose(false)} disabled={loading}>ยกเลิก</button>
              &nbsp;
              <button className="btn btn-primary" onClick={onSave} disabled={loading}>บันทึก</button>
            </div>
            {/* <button onClick={submit} disabled={loading}>{loading ? "Checking..." : "Confirm"}</button> */}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}